export const FORM_SUBMISSIONS_LOAD_ERROR = 'Could not load form submissions.';

export const FORM_SUBMISSIONS_ZIP_EXPORT_ERROR =
  'Could not export submissions archive. Check your network connection and try again.';

export const FORM_RESPONSE_PDF_EXPORT_ERROR = 'Could not export form response.';

export const FEEDS_FORMS_TAB_ROUTE = '/feeds#forms';
